"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSnowflakeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28.08 18.87l-1.1-1.67-3.22 2.12L18 16l5.76-3.32 3.22 2.12 1.1-1.67-2.38-1.57 2.92-1.69-1-1.74-2.92 1.69-.18-2.84-1.99.12.23 3.84L17 14.27V7.62l3.45-1.73-.9-1.78L17 5.38V2h-2v3.38l-2.55-1.27-.9 1.78L15 7.62v6.65l-5.76-3.33.23-3.84-1.99-.12-.18 2.84-2.92-1.69-1 1.74 2.92 1.69-2.38 1.57 1.11 1.67 3.21-2.12L14 16l-5.76 3.32-3.21-2.12-1.11 1.67 2.38 1.57-2.92 1.69 1 1.74 2.92-1.69.18 2.84 1.99-.12-.23-3.84L15 17.73v6.65l-3.45 1.73.9 1.78L15 26.62V30h2v-3.38l2.55 1.27.9-1.78L17 24.38v-6.65l5.76 3.33-.23 3.84 1.99.12.18-2.84 2.92 1.69 1-1.74-2.92-1.69 2.38-1.57z" })));
}
exports.default = SvgSnowflakeOutline;
//# sourceMappingURL=SnowflakeOutline.js.map